import React from 'react';
import "../css/style.css";

const PostGrid = () => {
    const posts = [
        { id: 1, title: 'Paket Wisata 1', image: "../image/post/paket 1.jpeg", desc: "Nikmati libur bersama keluarga dan orang tercinta." },
        { id: 2, title: 'Paket Wisata 2', image: "../image/post/paket 2.jpeg", desc: "Banyak promo untuk tiket & hotel kesayanganmu. Dapatkan diskon harga terbaik agar bujet liburan kamu semakin hemat. Tidak ada alasan lagi untuk menunda liburan kamu. Nikmati libur bersama keluarga dan orang tercinta." },
        { id: 3, title: 'Paket Wisata 3', image: "../image/post/paket 3.jpeg", desc: "Nikmati libur bersama keluarga dan orang tercinta." },
        { id: 4, title: 'Paket Wisata 4', image: "../image/post/paket 4.jpeg", desc: "Nikmati libur bersama keluarga dan orang tercinta." },
        { id: 5, title: 'Paket Wisata 5', image: "../image/post/paket 5.jpeg", desc: "Nikmati libur bersama keluarga dan orang tercinta." },
        { id: 6, title: 'Paket Wisata 6', image: "../image/post/paket 6.jpeg", desc: "Nikmati libur bersama keluarga dan orang tercinta." },
    ];

    return (
        <section className="px-6 py-10 max-w-7xl mx-auto">
            <h2 className="text-2xl font-semibold mb-6">
                🌍 Travel the World Without Breaking the Bank!
            </h2>

            <div className="flex overflow-x-auto space-x-4 pb-4">
                {posts.map((post, index) => (
                    <div key={index} className="min-w-[250px] w-64 bg-white rounded-xl shadow-md">
                        <img src={post.image} alt={post.title} className="w-full h-40 object-cover rounded-t-xl" />
                        <div className="p-4 text-left">
                            <h3 className="font-bold">{post.title}</h3>
                            <p className="text-sm text-gray-600">{post.desc}</p>
                            <a href="/" className="text-blue-500 text-sm">Read More ...</a>
                        </div>
                    </div>
                ))}
            </div>

            <div className="mt-8 flex justify-center">
                <button className="mt-6 px-6 py-2 bg-blue-500 text-white rounded-xl hover:bg-blue-600">
                    See All Package
                </button>
            </div>
            {/* <Container>
                <div className="post-grid">
                    {posts.map((post) => (
                        <PostCard key={post.id} {...post} className="post-card" />
                    ))}
                </div>
            </Container> */}
        </section>
    );
};

export default PostGrid;
